import {Component, ViewChild, OnInit} from '@angular/core';
import { environment } from '../../environments/environment';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { AuthService } from "../auth.service";
import { UtilsService } from "../shared/shared.module";
import * as _ from "lodash";

declare let swal:any;

@Component({
  selector: 'app-add-admin',
  templateUrl: './add-admin.component.html',
  styleUrls: ['./add-admin.component.css']
})
export class AddAdminComponent implements OnInit {

  errors: any = {};
  isLoading: boolean = false;
  isUpdate: boolean = false;

  admin: any = {
    email: '',
    phone: '',
    firstname: '',
    lastname: '',
    password: '',
    confirm_password: ''
  };

  environment: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private utilsService: UtilsService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.environment = environment;
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      this.utilsService.scrollTop();
    });

    this.route.params.subscribe(params => {
      let id = params['id'];
      if (this.authService.currentIsSuperAdmin()) {
        if (id) {
          this.isUpdate = true;
          this.isLoading = true;
          this.http.get(environment.API_PATH + '/admin/detail/' + id, {withCredentials: true})
          .subscribe(
            data => {
              this.admin = data;
              this.isLoading = false;
            },
            err => {
              this.isLoading = false;
              if (err.status === 401) {

                this.router.navigate(['/connexion']);
              } else if (err.status === 404) {
                this.utilsService.displayNotif("Cet admin n'existe pas", "danger");
                this.router.navigate(['../..'], {relativeTo: this.route});
              } else {
                this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
              }
            });
        }
      }
      else {
        this.router.navigate(['administration', 'home']);
      }
    })
  }

  goBack() {
    this.router.navigate(['administration', 'administrateurs']);
  }

  cancelSubmit() {
    this.router.navigate(['../..'], {relativeTo: this.route});
  }

  submitForm(form) {
    this.errors = {};
    if (form.invalid)
      return;

    this.isLoading = true;

    let req;
    if (!this.isUpdate)
      req = this.http.post(environment.API_PATH + '/admin/create', this.admin, {withCredentials: true} );
    else
      req = this.http.put(environment.API_PATH + '/admin/update', this.admin, {withCredentials: true} );

    req.subscribe(response => {
      this.isLoading = false;
      if (!this.isUpdate)
        this.utilsService.displayNotif('L\'administrateur a bien été créé', 'success');
      else
        this.utilsService.displayNotif('L\'administrateur a bien été modifié', 'success');
      this.router.navigate([this.router.url.split('/')[1], 'administrateurs']);
    }, err => {
      this.isLoading = false;
      if (err.status === 401) {

        this.router.navigate(['/connexion']);
      } else {
        this.isLoading = false;
        if (err.status === 401) {
          var errors = err.error;
          if (errors.error) {
            if (errors.error.status === 401) {

              this.router.navigate(['/connexion']);
            } else if (errors.error.status === 403) {
              if (errors.error.details.redirect)
                this.router.navigate([errors.error.details.redirect]);
              else if (errors.error.redirect) {
                this.router.navigate([errors.error.redirect]);
              }
              else
                this.authService.logout()
            } else {
              this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
            }
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        } else if (err.status == 400) {
          var details = err.error.error.details;
          if (!_.isEmpty(details)) {
            if ('general' in details) {
              for (var i in details.general) {
                this.utilsService.displayNotif(details.general[i], "danger");
              }
            }
            if ('field' in details) {
              for (var i in details.field) {
                  this.errors[i] = details.field[i];
              }
            }
          }
        }
        else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/add-admin/add-admin.component.ts